import { useQuery } from '@tanstack/react-query'

import { getTransactionEvidenceEmailFile } from '@src/api'
import { DefaultApiGetTransactionEvidenceEmailFileRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchTransactionEvidenceEmailFile = (
  params: DefaultApiGetTransactionEvidenceEmailFileRequest
) => {
  const { axiosInstance } = useAxios()
  axiosInstance.defaults.responseType = 'arraybuffer'

  return useQuery({
    enabled: !!params.userAccountId && !!params.transactionEvidenceEmailFileId,
    queryFn: () => getTransactionEvidenceEmailFile(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_TRANSACTION_EVIDENCE_EMAIL_FILE,
      params.userAccountId,
      params.transactionEvidenceEmailFileId,
    ],
  })
}
